/**
 * 화면 테마 — 기본은 시스템을 따르고, 마이페이지에서 라이트/다크로 고정할 수 있다.
 *
 * 저장: localStorage('tomato_theme') = 'light' | 'dark' (없으면 시스템).
 * 적용: <html data-theme="..."> — CSS가 이 속성으로 토큰을 뒤집는다(index.css).
 * 첫 페인트 전 적용은 index.html의 부트 스크립트가 담당한다(테마 깜빡임 방지).
 * 여기서는 전환 시 브라우저 크롬 색(theme-color meta)까지 맞춘다.
 */

export type ThemeChoice = 'system' | 'light' | 'dark';

const KEY = 'tomato_theme';
const CHROME_COLORS = { light: '#ffffff', dark: '#161618' } as const;

export function getThemeChoice(): ThemeChoice {
  try {
    const raw = localStorage.getItem(KEY);
    return raw === 'light' || raw === 'dark' ? raw : 'system';
  } catch {
    return 'system';
  }
}

export function setThemeChoice(choice: ThemeChoice): void {
  try {
    if (choice === 'system') localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, choice);
  } catch {
    /* 프라이빗 모드 등 — 이번 세션만 적용되고 저장은 안 될 뿐. */
  }
  applyTheme(choice);
}

export function applyTheme(choice: ThemeChoice): void {
  const html = document.documentElement;
  if (choice === 'system') delete html.dataset.theme;
  else html.dataset.theme = choice;

  // 상태바·주소창 색을 헤더와 맞춘다. 고정 테마면 media 조건을 무시하도록 둘 다 덮는다.
  const metas = document.querySelectorAll<HTMLMetaElement>('meta[name="theme-color"]');
  metas.forEach((m) => {
    const scheme = m.media.includes('dark') ? 'dark' : 'light';
    m.content = choice === 'system' ? CHROME_COLORS[scheme] : CHROME_COLORS[choice];
  });
}
